import apiClient from './apiClient';
import type { PointLoadBatchResponse, PointLoadSaveRow } from '../types/pointLoadTest';

/** Load the whole work-order PLT table from ANY of its samples' WOD keys. */
export const getPointLoadBatch = async (workOrderDetailKey: string): Promise<PointLoadBatchResponse> => {
  const r = await apiClient.get<PointLoadBatchResponse>(
    `/workorderdetails/${workOrderDetailKey}/pointload-batch`,
  );
  return r.data;
};

/** Save the whole work-order PLT table (one row per sample). */
export const savePointLoadBatch = async (
  workOrderDetailKey: string,
  rows: PointLoadSaveRow[],
): Promise<PointLoadBatchResponse> => {
  const r = await apiClient.put<PointLoadBatchResponse>(
    `/workorderdetails/${workOrderDetailKey}/pointload-batch`,
    { rows },
  );
  return r.data;
};
